import { render, staticRenderFns } from "./claimStatusesList.vue?vue&type=template&id=a6b96f8e&scoped=true&"
import script from "./claimStatusesList.vue?vue&type=script&lang=js&"
export * from "./claimStatusesList.vue?vue&type=script&lang=js&"
import style0 from "./claimStatusesList.vue?vue&type=style&index=0&id=a6b96f8e&lang=scss&scoped=true&"
import style1 from "./claimStatusesList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6b96f8e",
  null
  
)

export default component.exports